interface NetworkInformation {
    effectiveType?: string
    saveData?: boolean
}

/**
 * Collects client-side device context information useful for chatbot interactions.
 * No additional permissions are required — all values are available by default in the browser.
 */
export function collectDeviceContext() {
    const connection = (
        navigator as Navigator & { connection?: NetworkInformation }
    ).connection

    return {
        dateTime: new Date().toISOString(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        language: navigator.language,
        languages: [...navigator.languages],
        url: window.location.href,
        pathname: window.location.pathname,
        pageTitle: document.title,
        referrer: document.referrer || undefined,
        screenWidth: screen.width,
        screenHeight: screen.height,
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight,
        devicePixelRatio: window.devicePixelRatio,
        maxTouchPoints: navigator.maxTouchPoints,
        online: navigator.onLine,
        connectionType: connection?.effectiveType,
        saveData: connection?.saveData,
        darkMode: window.matchMedia('(prefers-color-scheme: dark)').matches,
        reducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)')
            .matches,
        historyLength: window.history.length,
    }
}
